import { BrowserRouter, Routes, Route, Link } from "react-router"
import Dashboard from "./components/Dashboard"
import CodeAnalyticsPage from "./components/CodeAnalyticsPage"
import AccountAnalyticsPage from "./components/AccountAnalyticsPage"
import Profile from "./components/Profile"
import DevelopersPage from "./components/DevelopersPage"
import RequireAuth from "./components/RequireAuth"
import { UpgradeProvider } from "./hooks/useUpgrade"

// The marketing landing page (`/`) is server-rendered ERB now; this SPA only
// owns the authenticated dashboard at `/app`.
function NotFound() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 text-center">
      <h1 className="font-display text-2xl text-ink dark:text-cloud">Nothing here.</h1>
      <Link to="/" className="mt-4 inline-block text-voltage-dark dark:text-voltage-light hover:underline">
        Go home
      </Link>
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      {/* One pricing box for every upgrade button in the app (#336). */}
      <UpgradeProvider>
        <Routes>
          <Route
            path="/app"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/app/analytics"
            element={
              <RequireAuth>
                <AccountAnalyticsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/app/codes/:token"
            element={
              <RequireAuth>
                <CodeAnalyticsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/app/profile"
            element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            }
          />
          <Route
            path="/app/developers"
            element={
              <RequireAuth>
                <DevelopersPage />
              </RequireAuth>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </UpgradeProvider>
    </BrowserRouter>
  )
}
